"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef, useContext } from "react";
import { cn } from "../../utils/cn.js";
import { drawerVariants } from "./Drawer.variants.js";
import { DrawerInsetContext } from "./DrawerPortal.js";
import { useResponsiveDrawerDirection } from "./useResponsiveDrawerDirection.js";
const DrawerPopup_DrawerPopup = /*#__PURE__*/ forwardRef(function({ className, slots, size, direction, height, ...props }, ref) {
    const isInsetActive = useContext(DrawerInsetContext);
    const effectiveDirection = useResponsiveDrawerDirection(direction, isInsetActive);
    const { popup } = drawerVariants({
        size,
        direction: effectiveDirection,
        inset: true === isInsetActive,
        height
    });
    return /*#__PURE__*/ jsx(Drawer.Popup, {
        ref: ref,
        className: cn(popup(), className, slots?.popup),
        ...props
    });
});
export { DrawerPopup_DrawerPopup as DrawerPopup };
